import {
    actionsCountry as actions
} from "./types";

export const setCountry = (country: string) => {
    return {
        type: actions.SET_COUNTRY,
        payload: country,
    };
};